import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { EMPLOYEE_API } from "./apiRoutes";

interface UseGetEmployeeGridProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getEmployeeGrid = async (data: any) => {
  return await axiosAuth.post(`${EMPLOYEE_API}/grid`, data);
};

const useGetEmployeeGrid = ({
  data,
  queryParams,
}: UseGetEmployeeGridProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["employee-list"],
    queryFn: () => getEmployeeGrid(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetEmployeeGrid;
